import { createRoot } from "react-dom/client"
import { App } from "./App"
import React from "react"
import "./locales/config"
import { ApolloProvider } from "@apollo/client"
import { client } from "./graphql/client"
import * as Sentry from "@sentry/react"
import PiwikPro from "@piwikpro/react-piwik-pro"
import FontStyles from "./fonts/FontStyles"
import { CustomWindow } from "./custom"
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from "react-router-dom"

declare let window: CustomWindow

// Sentry
const sentryDsn = window.env.REACT_APP_SENTRY_DSN
Sentry.init({
  dsn: sentryDsn,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],

  replaysOnErrorSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  tracesSampleRate: 0.1,
})

// Piwik Pro Analytics
if (window.env.REACT_APP_PIWIK_URL && window.env.REACT_APP_PIWIK_CONTAINER_ID) {
  PiwikPro.initialize(window.env.REACT_APP_PIWIK_CONTAINER_ID, window.env.REACT_APP_PIWIK_URL)
}

if (window.env.REACT_APP_USE_TEST_RESOURCES) {
  const prodIcon = document.getElementById("favicon")
  prodIcon?.remove()
  const devIcon = document.createElement("link")
  devIcon.rel = "icon"
  devIcon.href = "static/logo/favicon_dev.svg"
  document.head.appendChild(devIcon)
}

export const RECAPTCHA_SITE_KEY = window.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY
export const STRIPE_PUBLIC_KEY = window.env.REACT_APP_STRIPE_PUBLIC_KEY

const container = document.getElementById("js-framework-root")
const root = createRoot(container!)

root.render(
  <div>
    <ApolloProvider client={client}>
      <FontStyles />
      <App />
    </ApolloProvider>
  </div>,
)
